import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

import Home from "./views/Home.vue";
import Converter from "./views/Converter.vue";
import AboutUs from "./views/AboutUs.vue";
import AboutProject from "./views/AboutProject.vue";
import Projects from "./views/Projects.vue";
import Products from "./views/Products.vue";
import ContactUs from "./views/ContactUs.vue";
import NotFound from "./views/NotFound.vue";
import FileConverter from "./views/converter/FileConverter.vue";
import ConverterAPI from "./views/converter/ConverterAPI.vue";
import DownloadAttachments from "./views/converter/DownloadAttachments.vue";
import TextConverter from "./views/converter/TextConverter.vue";
import NewsList from "./views/NewsList.vue";
import LatynAlphabet from "./views/LatynAlphabet.vue";
import Grammar from "./views/latynalphabet/Grammar.vue";
import Leaders from "./views/Leaders.vue";
import Structrue from "./views/Structrue.vue";

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: "history",
  routes: [
    {
      name: "home",
      path: "/:ln(kz|latyn|tote)?/",
      component: Home
    },
    {
      path: `/:ln(kz|latyn|tote)?/home`,
      redirect: "/:ln(kz|latyn|tote)?/"
    },
    {
      name: "projects",
      path: `/:ln(kz|latyn|tote)?/projects`,
      component: Projects
    },
    {
      name: "products",
      path: `/:ln(kz|latyn|tote)?/products`,
      component: Products
    },
    {
      name: "NewsList",
      path: `/:ln(kz|latyn|tote)?/article`,
      component: NewsList
    },
    {
      name: "contactUs",
      path: `/:ln(kz|latyn|tote)?/contactUs`,
      component: ContactUs
    },
    {
      name: "alphabet",
      path: `/:ln(kz|latyn|tote)?/alphabet`,
      component: LatynAlphabet
    },
    {
      name: "grammar",
      path: `/:ln(kz|latyn|tote)?/grammar`,
      component: Grammar
    },
    {
      name: "leaders",
      path: `/:ln(kz|latyn|tote)?/leaders`,
      component: Leaders
    },
    {
      name: "aboutus",
      path: `/:ln(kz|latyn|tote)?/about/us`,
      component: AboutUs
    },
    {
      name: "structrue",
      path: `/:ln(kz|latyn|tote)?/structure`,
      component: Structrue
    },
    {
      name: "aboutproject",
      path: `/:ln(kz|latyn|tote)?/about/project`,
      component: AboutProject
    },
    {
      path: `/:ln(kz|latyn|tote)?/convert`,
      redirect: {
        path: `/:ln(kz|latyn|tote)?/converter`
      }
    },
    {
      path: `/:ln(kz|latyn|tote)?/converter`,
      component: Converter,
      children: [
        {
          name: "text",
          path: "",
          component: TextConverter,
          alias: "text"
        },
        {
          name: "document",
          path: "document",
          component: FileConverter
        },
        {
          name: "api",
          path: "api",
          component: ConverterAPI
        },
        {
          name: "download",
          path: "download",
          component: DownloadAttachments
        }
      ]
    },
    {
      name: "notfound",
      path: "*",
      component: NotFound
    }
  ]
});
